// extracted by mini-css-extract-plugin
export default {"mCard":"zA-z","image":"AA-z","imageNoBackground":"BA-z","imageHasCategory":"CA-z","fullWidth":"DA-z"};